'use client';

import {
  FeatureItem,
  FileTypeConfig,
  LandingFeatures,
  LandingHero,
  LandingUseCases,
} from '../_components';
import { Code, FileCode, Link2, ShieldCheck } from 'lucide-react';

const htmlConfig: FileTypeConfig = {
  type: 'html',
  title: '在线翻译网页文件·保持代码结构',
  subtitle: '网站本地化、邮件模板、电子出版的专业工具',
  description: '保留所有 HTML 标签与 CSS 样式',
  icon: <Code className="w-full h-full" />,
  gradientFrom: '#8b5cf6',
  gradientTo: '#7c3aed',
  accentColor: 'violet',
  particleColors: ['#8b5cf6', '#a78bfa', '#c4b5fd'],
  accept: {
    'text/html': ['.html', '.htm'],
  },
  stats: {
    users: '30万+',
    accuracy: '99.6%',
    files: '150万+',
  },
};

const htmlFeatures: FeatureItem[] = [
  {
    icon: ShieldCheck,
    title: '代码安全',
    description: '仅翻译可见文本，JS/CSS 完整保留',
  },
  {
    icon: Link2,
    title: '链接保护',
    description: 'href/src 路径零改动，链接正常工作',
  },
  {
    icon: FileCode,
    title: '标签保留',
    description: 'HTML 结构完整，SEO 元数据可选翻译',
  },
  {
    icon: Code,
    title: '样式不变',
    description: 'CSS 类名、内联样式完整保留',
  },
];

const htmlUseCases = [
  '网站本地化',
  'EDM模板',
  '电子书',
  '在线帮助文档',
  '产品页面',
  '技术博客',
];

const HtmlPage = () => {
  return (
    <div className="w-full">
      <LandingHero config={htmlConfig} />
      <LandingFeatures
        title="HTML 技术优势"
        features={htmlFeatures}
        gradientFrom={htmlConfig.gradientFrom}
        gradientTo={htmlConfig.gradientTo}
      />
      <LandingUseCases
        useCases={htmlUseCases}
        gradientFrom={htmlConfig.gradientFrom}
        gradientTo={htmlConfig.gradientTo}
      />
    </div>
  );
};

export default HtmlPage;
